import { Controller } from 'stimulus';

// One-tap Mark complete on a phone maintenance row
// (Mobile::MaintenanceCompletionsController). The tap records it; the row
// turns to Done with an Undo button at its end for 10 seconds, in the row
// itself so nothing covers the list. Undo puts the row back as it was.
//
//   <div class="mb-eq-row" data-controller="mobile-tick" data-mobile-tick-url="/m/equipment/1/maintenances/2/completions">
//     <button class="mb-tick" data-target="mobile-tick.tick" data-action="mobile-tick#complete">
//     <small data-target="mobile-tick.status">...</small>
const UNDO_MS = 10000;

export default class extends Controller {
  static targets = ['tick', 'status'];

  connect() {
    this.original = this.statusTarget.innerHTML;
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  complete(event) {
    event.preventDefault();
    if (this.busy || this.element.classList.contains('is-done')) return;

    this.busy = true;
    this.tickTarget.disabled = true;
    this.send(this.data.get('url'), 'POST').then(({ ok, data }) => {
      this.busy = false;
      if (!ok) {
        this.tickTarget.disabled = false;
        this.showError(data.error);
        return;
      }
      this.undoUrl = data.undo_url;
      this.element.classList.add('is-done');
      this.statusTarget.textContent = data.status;
      this.statusTarget.classList.remove('mb-tick-error');
      this.showUndo();
    });
  }

  undo(event) {
    event.preventDefault();
    if (this.busy || !this.undoUrl) return;

    this.busy = true;
    clearTimeout(this.timer);
    this.undoButton.disabled = true;
    this.send(this.undoUrl, 'DELETE').then(({ ok, data }) => {
      this.busy = false;
      this.removeUndo();
      if (!ok) {
        this.showError(data.error);
        return;
      }
      this.undoUrl = null;
      this.element.classList.remove('is-done');
      this.statusTarget.innerHTML = this.original;
      this.tickTarget.disabled = false;
    });
  }

  showUndo() {
    this.removeUndo();
    this.undoButton = document.createElement('button');
    this.undoButton.type = 'button';
    this.undoButton.className = 'mb-tick-undo';
    this.undoButton.textContent = 'Undo';
    this.undoButton.addEventListener('click', (event) => this.undo(event));
    this.element.appendChild(this.undoButton);
    this.timer = setTimeout(() => this.removeUndo(), UNDO_MS);
  }

  removeUndo() {
    clearTimeout(this.timer);
    if (this.undoButton) this.undoButton.remove();
    this.undoButton = null;
  }

  showError(message) {
    this.statusTarget.textContent = message || "Couldn't save. Check the connection and try again.";
    this.statusTarget.classList.add('mb-tick-error');
  }

  send(url, method) {
    const token = document.querySelector('meta[name="csrf-token"]');
    return fetch(url, {
      method,
      credentials: 'same-origin',
      redirect: 'manual',
      headers: { Accept: 'application/json', 'X-CSRF-Token': token ? token.content : '' },
    }).then((response) => {
      if (response.type === 'opaqueredirect' || response.redirected) return { ok: false, data: {} };
      return response.json().catch(() => null)
        .then((data) => ({ ok: response.ok && data !== null, data: data || {} }));
    }).catch(() => ({ ok: false, data: {} }));
  }
}
